export const forwardParams = (urlToForward: string) => {
  const newURL = new URL(urlToForward);
  const allowedParams = ['ecid', 'jumpid'];

  const searchParams = new URLSearchParams(window.location.search);

  if (searchParams.size === 0) return newURL.toString();

  for (const [key, value] of searchParams) {
    if (allowedParams.includes(key) && !newURL.searchParams.has(key)) {
      newURL.searchParams.append(key, value);
    }
  }

  return newURL.toString();
};
